import { axiosInstance } from '.'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import {
  SEARCH_WALLET_TOPUPS_V1,
  WALLET_TOPUP_STATUS_V1,
  SEARCH_WALLET_WITHDRAWALS_V1,
  WALLET_WITHDRAWAL_STATUS_V1,
  ADMIN_INVESTOR_WALLET_V1,
} from './endpoints'

export const walletAdminServices = {
  searchTopups: async (params: Record<string, string | number | undefined>) => {
    try {
      const data = await axiosInstance.get(SEARCH_WALLET_TOPUPS_V1, {
        params: removeEmptyValueFromObject(params),
      })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  updateTopupStatus: async (
    id: number,
    payload: {
      status: string
      actualAmountReceived?: number
      estimatedChargesCents?: number
      rejectionReason?: string
    },
  ) => {
    try {
      const data = await axiosInstance.patch(WALLET_TOPUP_STATUS_V1(id), payload)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  searchWithdrawals: async (params: Record<string, string | number | undefined>) => {
    try {
      const data = await axiosInstance.get(SEARCH_WALLET_WITHDRAWALS_V1, {
        params: removeEmptyValueFromObject(params),
      })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  updateWithdrawalStatus: async (id: number, status: string) => {
    try {
      const data = await axiosInstance.patch(WALLET_WITHDRAWAL_STATUS_V1(id), { status })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  getInvestorWallet: async (investorId: number) => {
    try {
      const data = await axiosInstance.get(ADMIN_INVESTOR_WALLET_V1(investorId))
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
}
